import Const from 'constants';

const defaultState = {
    data: {},
    isActive(playerId, settingName) {
        return this.data.hasOwnProperty(playerId) && settingName === this.data[playerId];
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.PLAYER_SETTING_POPUP_SET_STATE) {
        const {playerId, isActive, settingName} = action.data;
        const data = isActive ? {[playerId]: settingName} : {};
        state = {...state, data};
    }

    return state;
}
